<template>
    <div style="min-height: 700px">
        <organ-info-view :organ-id="organId" :show-warning-text="true" class="my-3"></organ-info-view>

        <organ-seal-edit :organ-id="organId"></organ-seal-edit>

        <organ-contact-person-edit :owner-id="organId" :person-type="personType" class="my-3"></organ-contact-person-edit>
    </div>
</template>

<script>
import dictionary from "@/utils/dictionary";
import OrganInfoView from "@/components/user/OrganInfoView";
import OrganContactPersonEdit from "@/components/user/OrganContactPersonEdit";
import OrganSealEdit from "@/components/user/OrganSealEdit";
export default {
    name: "OrganInfoEdit",
    components: {OrganSealEdit, OrganInfoView, OrganContactPersonEdit, },
    data: function () {
        return {
            organId: this.$store.state.userInfo.userId,
            personType: dictionary.personType.ORGAN_CONTACT,

            organSealInfo: null,
        };
    },
    mounted() {

    },
    methods: {
    }
}
</script>

<style scoped>

</style>